import { useContext } from 'react';
import { FlexContainer, ModalContext, Modals, Separator, Text } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { ValidationCompensationProps } from './types';

const ValidationCompensation = ({
  initial,
  newAmount,
  previousYears,
  total,
}: ValidationCompensationProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const { hideModal } = useContext(ModalContext);
  return (
    <Modals.Centered
      maxSize="M"
      buttonsInline
      hasClose
      onClose={hideModal}
      title={t('Compensation.modal.validation.title')}
      description={t('Compensation.modal.validation.description')}
      primaryButton={{
        label: t('Compensation.modal.button'),
        onClick: hideModal,
      }}
    >
      <FlexContainer direction="column" align="center" fullWidth>
        <FlexContainer direction="column" align="flex-start" gap="dimension_08" fullWidth>
          <FlexContainer align="center" justify="space-between" fullWidth>
            <Text type="paragraphs" color="grey" size="S_M_S">
              {t('Compensation.modal.validation.initial')}
            </Text>
            <Text type="paragraphs" color="grey" size="S_M_S">
              {YayoyakiFormatter.formatAmountMxn(Math.abs(Number(initial)))}
            </Text>
          </FlexContainer>
          <FlexContainer align="center" justify="space-between" fullWidth>
            <Text type="paragraphs" color="dark" size="S_M_S">
              {t('Compensation.modal.validation.new')}
            </Text>
            <Text type="paragraphs" color="dark" size="S_M_S">
              {YayoyakiFormatter.formatAmountMxn(Math.abs(Number(newAmount)))}
            </Text>
          </FlexContainer>
          <FlexContainer align="center" justify="space-between" fullWidth>
            <Text type="paragraphs" color="fresh" size="S_M_S">
              {t('Compensation.modal.validation.previousYears')}
            </Text>
            <Text type="paragraphs" color="fresh" size="S_M_S">
              {YayoyakiFormatter.formatAmountMxn(Math.abs(Number(previousYears)))}
            </Text>
          </FlexContainer>
          <Separator />
          <FlexContainer align="center" justify="space-between" fullWidth>
            <Text type="paragraphs" color="cold" size="S_M_S">
              {t('Compensation.modal.validation.total')}
            </Text>
            <Text type="paragraphs" color="cold" size="S_M_S">
              {YayoyakiFormatter.formatAmountMxn(Math.abs(Number(total)))}
            </Text>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </Modals.Centered>
  );
};

export default ValidationCompensation;
